import { apiFetch, erroApi } from './api';
import { toast } from 'sonner';

export async function getHome() {
  const r = await apiFetch('/admin/homepage');
  if (!r.ok) throw new Error('falha');
  return r.json();
}

export async function salvarRascunho(cfg) {
  const r = await apiFetch('/admin/homepage/rascunho', { method: 'PUT', body: JSON.stringify(cfg) });
  if (!r.ok) {
    toast.error(erroApi((await r.json().catch(() => ({}))).detail));
    return false;
  }
  toast.success('Rascunho salvo. A página pública ainda não mudou.');
  return true;
}

export async function publicarHome() {
  const r = await apiFetch('/admin/homepage/publicar', { method: 'POST' });
  if (!r.ok) {
    toast.error(erroApi((await r.json().catch(() => ({}))).detail));
    return false;
  }
  toast.success('Publicado! As alterações já estão no catálogo.');
  return true;
}

export async function cancelarRascunho() {
  const r = await apiFetch('/admin/homepage/cancelar', { method: 'POST' });
  if (r.ok) toast.success('Alterações do rascunho descartadas.');
  return r.ok;
}
